import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleChartsModule } from 'angular-google-charts';
import { DonutChartComponent } from './components/donut-chart/donut-chart.component';
import { DonutTabsComponent } from './components/donut-tabs/donut-tabs.component';
import { MaterialModule } from '../material.module';
import { ScrollingModule } from '@angular/cdk/scrolling';

// components
import { ProfileComponent } from './components/candidate-profile/candidate-profile.component';
import { TableComponent } from './components/table/table.component';
import { EventTabsComponent } from './components/event-tabs/event-tabs.component';
import { StatsDataComponent } from './components/stats-data/stats-data.component';
import { SemicircularProgressbarComponent } from './components/semicircular-progressbar/semicircular-progressbar.component';
import { ProfileCardComponent } from './components/profile-card/profile-card.component';
// import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
// @NgModule({
//   declarations: [DonutChartComponent, DonutTabsComponent, EventTabsComponent, StatsDataComponent, SemicircularProgressbarComponent, ProfileCardComponent, ProfileComponent,TableComponent],
import { HeaderComponent } from './components/header/header.component';
import { OngoingtaskComponent } from './components/ongoingtask/ongoingtask.component';
import { TeamMemberComponent } from './components/team-member/team-member.component';
import { SnackbarComponent } from './components/snackbar/snackbar.component';
// import { ThemeService } from 'ng2-charts';
import { SideNavigationComponent } from './components/side-navigation/side-navigation.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { MatTableComponent } from './components/mat-table/mat-table.component';
import { ViewProfileComponent } from './components/view-profile/view-profile.component';
import { MatTableWithChipComponent } from './components/mat-table-with-chip/mat-table-with-chip.component';
import { ChatBoxComponent } from './components/chat-box/chat-box.component';
import { StatsinflowDataComponent } from './components/statsinflow-data/statsinflow-data.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { AttachmentDialogComponent } from './components/attachment-dialog/attachment-dialog.component';
import { DragDirective } from './components/attachment-dialog/drag-drop.directive';
import { PhonenumberComponent } from './components/dynamicUI/controls/phonenumber/phonenumber.component';

import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { RoleSelectComponent } from './components/reject-select/role-select.component';
import { AttachmentComponent } from './components/attachment/attachment.component';
import { InitialsPipe } from './pipes/initials.pipe';
import { CandidateListComponent } from './components/candidate-list/candidate-list.component';
import { EventCardsComponent } from './components/event-cards/event-cards.component';
import { DynamicCandidateComponent } from './components/dynamic-candidate/dynamic-candidate.component';

// import { InputComponent } from './components/dynamicUI/controls/input/input/input.component';

import { DynamicCandidateProfileComponent } from './components/dynamic-candidate-profile/dynamic-candidate-profile.component';
import { PublicationComponent } from './components/publication/publication.component';
import { DynamicTableComponent } from './components/dynamic-table/dynamic-table.component';
import { StylePaginatorDirective } from './components/dynamic-table/style-paginator.directive';
import { FilterMenuComponent } from './components/filter-menu/filter-menu.component';
import { CapitalizeService } from './pipes/capitalize.pipe';

// for dialog
import { SearchDialog } from 'src/app/shared/components/header/header.component';
import { UnauthComponent } from './components/unauth/unauth.component';

// for activities to work
import { CandidatesComponent } from 'src/app/modules/schedulerpersona/components/candidates/candidates.component';
import { ActivityDialogComponent } from 'src/app/modules/activities/activity-dialog/activity-dialog.component';
import { ActivityCheckSuitabilityComponent } from 'src/app/modules/activities/activity-check-suitability/activity-check-suitability.component';
import { ActivityCorrespondenceComponent } from 'src/app/modules/activities/activity-correspondence/activity-correspondence.component';
import { ActivityScheduleinterviewComponent } from 'src/app/modules/activities/activity-scheduleinterview/activity-scheduleinterview.component';
import { ActivityStatusChangeComponent } from 'src/app/modules/activities/activity-status-change/activity-status-change.component';
import { ActivityHRInterviewComponent } from 'src/app/modules/activities/activity-hrinterview/activity-hrinterview.component';
import { CoupledActivityComponent } from 'src/app/modules/activities/coupled-activity/coupled-activity.component';
import { ActivityFooterComponent } from 'src/app/modules/activities/activity-footer/activity-footer.component';
import { dateTransform } from 'src/app/shared/pipes/date-Transform.pipe';
import { CamelToLabelPipe } from './pipes/camel-to-label.pipe';

import { CoupledStatuschangeActivityComponent } from 'src/app/modules/activities/coupled-statuschange-activity/coupled-statuschange-activity.component';
import { CoupledSuitabilityActivityComponent } from 'src/app/modules/activities/coupled-suitability-activity/coupled-suitability-activity.component';
import { CoupledCorrespoandenceActivityComponent } from 'src/app/modules/activities/coupled-correspoandence-activity/coupled-correspoandence-activity.component';
import { CoupledSchdueleInterviewActivityComponent } from 'src/app/modules/activities/coupled-schduele-interview-activity/coupled-schduele-interview-activity.component';
import { CoupledHrpanelInterviewActivityComponent } from 'src/app/modules/activities/coupled-hrpanel-interview-activity/coupled-hrpanel-interview-activity.component';
import { ActivityUpdatePanelListComponent } from 'src/app/modules/activities/activity-update-panel-list/activity-update-panel-list.component';
import { ActivityUpdateOfferDetailComponent } from '../modules/activities/activity-update-offer-detail/activity-update-offer-detail.component';
import { SearchCandidatesComponent } from '../modules/schedulerpersona/components/search-candidates/search-candidates.component';
import { SearchCandidateDetailComponent } from '../modules/schedulerpersona/components/search-candidate-detail/search-candidate-detail.component';
import { CreateCandidateComponent } from './components/create-candidate/create-candidate.component';
import { DynamicFormComponent } from './components/dynamicUI/dynamic-form/dynamic-form.component';
import { DynamicFieldComponent } from './components/dynamicUI/dynamic-field/dynamic-field.component';
import { InputComponent } from './components/dynamicUI/controls/input/input.component';
import { ButtonComponent } from './components/dynamicUI/controls/button/button.component';
import { DateComponent } from './components/dynamicUI/controls/date/date.component';
import { LabelComponent } from './components/dynamicUI/controls/label/label.component';
import { SelectComponent } from './components/dynamicUI/controls/select/select.component';
import { AutocompleteComponent } from './components/dynamicUI/controls/autocomplete/autocomplete.component';
import { InputButtonComponent } from './components/dynamicUI/controls/input-button/input-button.component';
import { AttachComponent } from './components/attach/attach.component';
import { ChipfullwidthComponent } from './components/dynamicUI/controls/chipfullwidth/chipfullwidth.component';

import { ParserStatusComponent } from './components/parser-status/parser-status.component';
import { MaintenanceScreenComponent } from './components/maintenance-screen/maintenance-screen.component';
import { LinksComponent } from './components/links/links.component';
import { PrivacyConsentComponent } from './components/privacy-consent/privacy-consent.component';
import { SwitchMultiCasePipe } from './pipes/switch-multi-case.pipe';
import { ExcelDownloadComponent } from './components/excel-download/excel-download.component';
import { EventSkillTableComponent } from './components/event-skill-table/event-skill-table.component';
import { PatternValidation } from './directives/patternValidation.directive';
import { MaintenanceModeComponent } from './components/maintenance-mode/maintenance-mode.component';
import { ReproposetabComponent } from '../../app/modules/offerdb/components/reproposetab/reproposetab.component';
import { YearPickerComponent } from './components/year-picker/year-picker.component';
import {
  MultilpleFileAttachComponent,
  MultipleFilesDialogComponent,
} from './components/multilple-file-attach/multilple-file-attach.component';
import { MultipleFileDialogComponent } from './components/multiple-file-dialog/multiple-file-dialog.component';
import { CandidateAttachmentComponent } from './components/candidate-attachment/candidate-attachment.component';
import { InterviewDetailsComponent } from './components/interview-details/interview-details.component';
import { ConfirmPopupComponent } from './components/confirm-popup/confirm-popup.component';
import { NoWhiteSpcDirective } from './directives/no-white-spc.directive';
import { BaseChartDirective } from 'ng2-charts';
import { TableWithActionComponent } from './components/table-with-action/table-with-action.component';
import { MatCardModule } from '@angular/material/card';

@NgModule({
  declarations: [
    DonutChartComponent,
    DonutTabsComponent,
    EventTabsComponent,
    StatsDataComponent,
    ProfileComponent,
    TableComponent,
    HeaderComponent,
    OngoingtaskComponent,
    TeamMemberComponent,
    SnackbarComponent,
    ProfileCardComponent,
    SemicircularProgressbarComponent,
    PhonenumberComponent,
    SideNavigationComponent,
    MatTableComponent,
    ViewProfileComponent,
    MatTableWithChipComponent,
    StatsinflowDataComponent,
    AttachmentComponent,
    AttachmentDialogComponent,
    ConfirmDialogComponent,
    DragDirective,
    ChatBoxComponent,
    RoleSelectComponent,
    AttachmentComponent,
    InitialsPipe,
    CandidateListComponent,
    EventCardsComponent,
    DynamicCandidateComponent,
    CapitalizeService,
    DynamicFieldComponent,
    DynamicCandidateProfileComponent,
    PublicationComponent,
    DynamicTableComponent,
    FilterMenuComponent,
    StylePaginatorDirective,
    SearchDialog,
    CandidatesComponent,
    ActivityDialogComponent,
    ActivityCheckSuitabilityComponent,
    ActivityCorrespondenceComponent,
    ActivityScheduleinterviewComponent,
    ActivityStatusChangeComponent,
    ActivityHRInterviewComponent,
    CoupledActivityComponent,
    ActivityFooterComponent,
    dateTransform,
    CamelToLabelPipe,
    UnauthComponent,
    ActivityUpdatePanelListComponent,
    CoupledStatuschangeActivityComponent,
    CoupledSuitabilityActivityComponent,
    CoupledCorrespoandenceActivityComponent,
    CoupledSchdueleInterviewActivityComponent,
    CoupledHrpanelInterviewActivityComponent,
    ActivityUpdateOfferDetailComponent,
    SearchCandidatesComponent,
    SearchCandidateDetailComponent,
    CreateCandidateComponent,
    DynamicFormComponent,
    InputComponent,
    ButtonComponent,
    DateComponent,
    PatternValidation,
    LabelComponent,
    SelectComponent,
    AutocompleteComponent,
    InputButtonComponent,
    AttachComponent,
    ChipfullwidthComponent,
    ParserStatusComponent,
    MaintenanceScreenComponent,
    LinksComponent,
    PrivacyConsentComponent,
    SwitchMultiCasePipe,
    ExcelDownloadComponent,
    EventSkillTableComponent,
    MaintenanceModeComponent,
    ReproposetabComponent,
    YearPickerComponent,
    MultipleFilesDialogComponent,
    MultipleFileDialogComponent,
    MultilpleFileAttachComponent,
    CandidateAttachmentComponent,
    InterviewDetailsComponent,
    ConfirmPopupComponent,
    NoWhiteSpcDirective,
    TableWithActionComponent,
  ],
  imports: [
    CommonModule,
    GoogleChartsModule,
    MaterialModule,
    NgbModule,
    FormsModule,
    ScrollingModule,
    ReactiveFormsModule,
    RouterModule,
    BaseChartDirective,
    MatCardModule,
  ],

  exports: [
    DonutChartComponent,
    DonutTabsComponent,
    EventTabsComponent,
    StatsDataComponent,
    StatsinflowDataComponent,
    ProfileCardComponent,
    SemicircularProgressbarComponent,
    TeamMemberComponent,
    TableComponent,
    ProfileComponent,
    HeaderComponent,
    OngoingtaskComponent,
    SnackbarComponent,
    SideNavigationComponent,
    MatTableComponent,
    ViewProfileComponent,
    MatTableWithChipComponent,
    ChatBoxComponent,
    RoleSelectComponent,
    AttachmentComponent,
    AttachmentDialogComponent,
    CandidateListComponent,
    EventCardsComponent,
    DynamicCandidateComponent,
    DynamicFieldComponent,
    InitialsPipe,
    CapitalizeService,
    PublicationComponent,
    DynamicTableComponent,
    FilterMenuComponent,
    dateTransform,
    CamelToLabelPipe,
    CandidatesComponent,
    ActivityCorrespondenceComponent,
    ActivityScheduleinterviewComponent,
    ActivityCheckSuitabilityComponent,
    // ActivityQuestionnairesComponent,
    ActivityStatusChangeComponent,
    ActivityFooterComponent,
    CoupledActivityComponent,
    ActivityDialogComponent,
    ActivityHRInterviewComponent,
    ActivityCorrespondenceComponent,
    ActivityScheduleinterviewComponent,
    ActivityCheckSuitabilityComponent,
    ActivityUpdatePanelListComponent,
    ActivityUpdateOfferDetailComponent,
    SearchCandidatesComponent,
    SearchCandidateDetailComponent,
    StylePaginatorDirective,
    DynamicFormComponent,
    CreateCandidateComponent,
    AttachComponent,
    ParserStatusComponent,
    MaintenanceScreenComponent,
    LinksComponent,
    CoupledCorrespoandenceActivityComponent,
    PrivacyConsentComponent,
    SwitchMultiCasePipe,
    ExcelDownloadComponent,
    EventSkillTableComponent,
    PatternValidation,
    NoWhiteSpcDirective,
    ReproposetabComponent,
    YearPickerComponent,
    MultilpleFileAttachComponent,
    CandidateAttachmentComponent,
    InterviewDetailsComponent,
    ConfirmPopupComponent,
    TableWithActionComponent,
  ],
  providers: [],
})
export class SharedModule {}
